import React from 'react';
import { useTranslation } from 'react-i18next';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import useClasses from '../../hooks/useClasses';
import useTypedDispatch from '../../hooks/useTypedDispatch';
import { hideCrisisAlert } from '../../store/actions/UI';
import type { CrisisAlert } from '../../types';
import Button from '../Button';

import './style.scss';

export interface CrisisBannerProps extends Omit<CrisisAlert, 'field_type' | 'field_period'> {
  type: string;
}

const CrisisBanner: React.FC<CrisisBannerProps> = (props) => {
  const {
    nid,
    type,
    title,
    body,
  } = props;

  const dispatch = useTypedDispatch();
  const { t } = useTranslation();
  const { buildClass } = useClasses('CrisisBanner', type.toLowerCase());

  return (
    <div className={buildClass()}>
      <div className={buildClass('content')}>
        <h2 className={buildClass('heading')}>
          {title}
        </h2>

        <WysiwygField
          property="schema:text"
          html={body}
        />
      </div>

      <Button
        iconOnly
        icon="cross"
        aria-label={t('aria_labels.hide_crisis_alert')}
        onClick={() => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          dispatch(hideCrisisAlert(nid));
        }}
      />
    </div>
  );
};

export default CrisisBanner;
